/**
 * EditImages.jsx
 *
 * FIXES:
 *   1. Edit Images button was disabled=true in AdminDashboard — removed that
 *   2. Search replaced: react-search → live filter input connected to table
 *   3. Added A-Z / Z-A / Newest / Oldest sort options
 */

import { useState, useEffect, useMemo } from "react";
import { deletemediafile, getAllImagesAdmin } from "../../..";
import LoggedInNavbar from "../../../../Admin/helper/loggedInNavbar";
import { isAuthenticated } from "../../../../Auth/helper";
import Modal from "react-bootstrap/Modal";
import { getAllCategory, updatePoduct } from "../../../../Admin/helper";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { useNavigate } from "react-router-dom";

const EditImages = () => {
  const [videos, setvideos] = useState([]);
  const [loading, setLoading] = useState(false);
  const [modalitem, setmodelitem] = useState({});
  const [show, setShow] = useState(false);
  const [subCatgory, setSubCategory] = useState([]);
  const [getallcat, setallcat] = useState([]);
  const [uploadThumbNailfile, setuploadThumbNailfile] = useState(null);
  const [uploadafile, setuploadfile] = useState(null);
  const [updateMedia, setMedia] = useState(false);

  // Search & Sort state
  const [searchQuery, setSearchQuery] = useState("");
  const [sortOrder, setSortOrder] = useState("az"); // az | za | newest | oldest

  const navigate = useNavigate();

  const [uploadmedia, setupload] = useState({
    productName: "",
    subCategoryId: "0",
    description: null,
  });
  const { productName, description, subCategoryId } = uploadmedia;

  const handleClose = () => {
    setShow(false);
    setupload({ productName: "", subCategoryId: "0", description: "" });
    setuploadfile(null);
    setuploadThumbNailfile(null);
  };

  useEffect(() => {
    const userdata = async () => {
      const { token, user } = isAuthenticated();
      await getAllImagesAdmin(user._id, token).then((data) => setvideos(data));
      await getAllCategory(user._id, token)
        .then((re) => {
          setallcat(re.allCategory);
          setSubCategory(re.allsubCategory);
        })
        .catch(console.log);
    };
    userdata();
  }, [show, updateMedia]);

  // ── Live search + sort ────────────────────────────────────────────────────
  const filteredAndSorted = useMemo(() => {
    let result = [...videos];

    // Filter by search query
    const q = searchQuery.toLowerCase().trim();
    if (q) {
      result = result.filter(
        (item) =>
          item.productName?.toLowerCase().includes(q) ||
          item.productCategory?.categoryName?.toLowerCase().includes(q) ||
          item.subCategoryId?.subCategoryName?.toLowerCase().includes(q),
      );
    }

    // Sort
    result.sort((a, b) => {
      switch (sortOrder) {
        case "az":
          return a.productName?.localeCompare(b.productName);
        case "za":
          return b.productName?.localeCompare(a.productName);
        case "newest":
          return new Date(b.createdAt) - new Date(a.createdAt);
        case "oldest":
          return new Date(a.createdAt) - new Date(b.createdAt);
        default:
          return 0;
      }
    });

    return result;
  }, [videos, searchQuery, sortOrder]);

  const deletemedia = async (id) => {
    if (!window.confirm("Are you sure you want to delete this image?")) return;
    const { token, user } = isAuthenticated();
    await deletemediafile(user._id, token, id)
      .then((re) => {
        if (re.message) alert("Image deleted successfully");
        setMedia((v) => !v);
      })
      .catch(() => alert("Error in deleting image."));
  };

  const handleformfield = (name) => (e) => {
    setupload({ ...uploadmedia, [name]: e.target.value });
  };

  const handlesubmit = async (e) => {
    e.preventDefault();
    if (!productName) {
      alert("Image name is mandatory");
      return;
    }
    setLoading(true);
    const newform = new FormData();
    newform.append("myfile", uploadafile || null);
    newform.append("myfile1", uploadThumbNailfile || null);
    newform.append("productName", productName);
    newform.append("subCategoryId", subCategoryId);
    newform.append("description", description || null);
    const cur = isAuthenticated();
    await updatePoduct(
      cur.user._id,
      cur.token,
      modalitem._id,
      modalitem.productCategory._id,
      newform,
    )
      .then((ret) => {
        if (ret.message) {
          alert(ret.message);
          handleClose();
        }
        if (ret.error) {
          alert("Error in processing request");
        }
      })
      .catch(() => alert("Error in sending request"))
      .finally(() => setLoading(false));
  };

  // ── Shared styles ─────────────────────────────────────────────────────────
  const cardStyle = {
    backgroundColor: "#fff",
    borderRadius: "12px",
    boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
    border: "1px solid #e0e0e0",
    marginBottom: "20px",
  };
  const headerStyle = {
    backgroundColor: "#f8f9fa",
    color: "#2c3e50",
    borderBottom: "2px solid #e9ecef",
    padding: "16px 20px",
    borderRadius: "12px 12px 0 0",
    fontWeight: "600",
    fontSize: "18px",
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  };
  const thStyle = {
    backgroundColor: "#3B82F6",
    color: "#fff",
    padding: "14px 12px",
    textAlign: "left",
    fontWeight: "600",
    fontSize: "14px",
    position: "sticky",
    top: 0,
    zIndex: 1,
  };
  const tdStyle = { padding: "13px 12px", fontSize: "14px", color: "#495057" };

  return (
    <>
      <style>{`
        .modal-backdrop { z-index: 9998 !important; }
        .modal { z-index: 9999 !important; }
      `}</style>
      <LoggedInNavbar />
      <div
        style={{
          padding: "20px",
          backgroundColor: "#f8f9fa",
          minHeight: "100vh",
        }}
      >
        <div className="container">
          <div style={cardStyle}>
            <div style={headerStyle}>
              <span>
                <i className="fas fa-image me-2"></i>Edit Images
              </span>
              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <span
                  style={{
                    backgroundColor: "#3B82F6",
                    color: "#fff",
                    padding: "5px 12px",
                    borderRadius: 20,
                    fontSize: 13,
                  }}
                >
                  {filteredAndSorted.length} / {videos.length} images
                </span>
                <button
                  onClick={() => navigate("/adminDashboard")}
                  style={{
                    backgroundColor: "#6c757d",
                    color: "#fff",
                    border: "none",
                    borderRadius: 6,
                    padding: "8px 14px",
                    fontSize: 13,
                    cursor: "pointer",
                  }}
                >
                  <i className="fas fa-arrow-left me-1"></i> Back
                </button>
              </div>
            </div>

            <div style={{ padding: "20px" }}>
              {/* Search + Sort bar */}
              <div
                style={{
                  display: "flex",
                  gap: 10,
                  marginBottom: 16,
                  flexWrap: "wrap",
                }}
              >
                {/* Search input */}
                <div style={{ position: "relative", flex: 1, minWidth: 200 }}>
                  <i
                    className="fas fa-search"
                    style={{
                      position: "absolute",
                      left: 12,
                      top: "50%",
                      transform: "translateY(-50%)",
                      color: "#aaa",
                    }}
                  />
                  <input
                    type="text"
                    placeholder="Search images by name"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    style={{
                      width: "100%",
                      padding: "10px 12px 10px 36px",
                      border: "1px solid #e0e0e0",
                      borderRadius: 8,
                      fontSize: 14,
                      outline: "none",
                      boxSizing: "border-box",
                    }}
                  />
                  {searchQuery && (
                    <i
                      className="fas fa-times"
                      onClick={() => setSearchQuery("")}
                      style={{
                        position: "absolute",
                        right: 12,
                        top: "50%",
                        transform: "translateY(-50%)",
                        color: "#aaa",
                        cursor: "pointer",
                      }}
                    />
                  )}
                </div>

                {/* Sort dropdown */}
                <select
                  value={sortOrder}
                  onChange={(e) => setSortOrder(e.target.value)}
                  style={{
                    padding: "10px 14px",
                    border: "1px solid #e0e0e0",
                    borderRadius: 8,
                    fontSize: 14,
                    outline: "none",
                    background: "#fff",
                    cursor: "pointer",
                  }}
                >
                  <option value="az">Sort: A → Z</option>
                  <option value="za">Sort: Z → A</option>
                  <option value="newest">Sort: Newest First</option>
                  <option value="oldest">Sort: Oldest First</option>
                </select>
              </div>

              {/* No results */}
              {filteredAndSorted.length === 0 ? (
                <div
                  style={{
                    textAlign: "center",
                    padding: "40px",
                    color: "#6c757d",
                  }}
                >
                  <i className="fas fa-inbox fa-3x mb-3"></i>
                  <p>
                    {searchQuery
                      ? `No images found for "${searchQuery}"`
                      : "No images found"}
                  </p>
                </div>
              ) : (
                <div
                  style={{
                    maxHeight: 500,
                    overflowY: "auto",
                    border: "1px solid #e9ecef",
                    borderRadius: 8,
                  }}
                >
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <thead>
                      <tr>
                        <th style={thStyle}>Media Name</th>
                        <th style={thStyle}>Category</th>
                        <th style={thStyle}>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredAndSorted.map((item, key) => (
                        <tr
                          key={item._id}
                          style={{
                            borderBottom: "1px solid #f0f0f0",
                            backgroundColor: key % 2 === 0 ? "#fff" : "#f8f9fa",
                          }}
                        >
                          <td style={tdStyle}>
                            <i
                              className="fas fa-image me-2"
                              style={{ color: "#3B82F6" }}
                            ></i>
                            {item.productName}
                          </td>
                          <td style={tdStyle}>
                            {item.productCategory?.categoryName}
                          </td>
                          <td style={tdStyle}>
                            <button
                              onClick={() => {
                                setmodelitem(item);
                                setShow(true);
                                setupload({
                                  description: item.description,
                                  subCategoryId: item.subCategoryId?._id,
                                  productName: item.productName,
                                });
                              }}
                              style={{
                                background: "none",
                                border: "none",
                                color: "#007bff",
                                cursor: "pointer",
                                padding: 6,
                              }}
                              title="Edit"
                            >
                              <i className="fas fa-edit fa-lg"></i>
                            </button>
                            <button
                              onClick={() => deletemedia(item._id)}
                              style={{
                                background: "none",
                                border: "none",
                                color: "#dc3545",
                                cursor: "pointer",
                                padding: 6,
                              }}
                              title="Delete"
                            >
                              <i className="fas fa-trash fa-lg"></i>
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              )}
            </div>
          </div>
        </div>

        {/* Edit Modal */}
        <Modal
          show={show}
          onHide={handleClose}
          size="lg"
          backdrop="static"
          centered
        >
          <Modal.Header closeButton>
            <Modal.Title>
              <i className="fas fa-edit me-2"></i>Edit Image:{" "}
              {uploadmedia?.productName}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ maxHeight: "70vh", overflowY: "auto" }}>
            <form onSubmit={handlesubmit}>
              <div className="row g-3">
                <div className="col-sm-6">
                  <label className="form-label fw-500">Media Name</label>
                  <input
                    type="text"
                    className="form-control"
                    value={productName}
                    onChange={handleformfield("productName")}
                    placeholder="Enter media name"
                  />
                </div>
                <div className="col-sm-6">
                  <label className="form-label fw-500">Media Type</label>
                  <input
                    type="text"
                    className="form-control"
                    value={modalitem?.productCategory?.categoryName || ""}
                    disabled
                    style={{ background: "#f8f9fa" }}
                  />
                </div>
                <div className="col-sm-6">
                  <label className="form-label fw-500">Sub Category</label>
                  <select
                    className="form-select"
                    value={subCategoryId}
                    onChange={handleformfield("subCategoryId")}
                  >
                    {subCatgory.map((i) => (
                      <option key={i._id} value={i._id}>
                        {i.subCategoryName}
                      </option>
                    ))}
                  </select>
                </div>
                <div className="col-sm-6">
                  <label className="form-label fw-500">Description</label>
                  <textarea
                    className="form-control"
                    rows="2"
                    value={description || ""}
                    onChange={handleformfield("description")}
                    placeholder="Enter description"
                  />
                </div>
                <div className="col-sm-12">
                  <label className="form-label fw-500">Current Thumbnail</label>
                  <div>
                    <LazyLoadImage
                      src={modalitem?.thumbNailPathCDN}
                      height="80"
                      width="80"
                      style={{
                        border: "1px solid #e0e0e0",
                        borderRadius: 8,
                        padding: 4,
                      }}
                    />
                  </div>
                  <input
                    type="file"
                    className="form-control mt-2"
                    accept="image/*"
                    onChange={(e) => setuploadThumbNailfile(e.target.files[0])}
                  />
                </div>
                <div className="col-sm-12">
                  <label className="form-label fw-500">Current Image</label>
                  <div>
                    <LazyLoadImage
                      src={modalitem?.productPathCDN}
                      style={{
                        width: "100%",
                        height: 200,
                        objectFit: "cover",
                        borderRadius: 8,
                        border: "1px solid #e0e0e0",
                      }}
                    />
                  </div>
                  <input
                    type="file"
                    className="form-control mt-2"
                    accept="image/*"
                    onChange={(e) => setuploadfile(e.target.files[0])}
                  />
                </div>
              </div>
              <div style={{ marginTop: 20, textAlign: "center" }}>
                <button
                  type="submit"
                  disabled={loading}
                  className="btn"
                  style={{
                    backgroundColor: loading ? "#6c757d" : "#3B82F6",
                    color: "#fff",
                    borderRadius: 8,
                    padding: "12px 28px",
                    fontSize: 15,
                    fontWeight: 500,
                    cursor: loading ? "not-allowed" : "pointer",
                  }}
                >
                  {loading ? (
                    <>
                      <i className="fas fa-spinner fa-spin me-2"></i>Updating...
                    </>
                  ) : (
                    <>
                      <i className="fas fa-save me-2"></i>Update Image
                    </>
                  )}
                </button>
              </div>
            </form>
          </Modal.Body>
        </Modal>
      </div>
    </>
  );
};

export default EditImages;
